import { z } from "zod";

export const bookAuthorSchema = () => {
  return z.object({
    name: z.string().min(1),
    name_inverted: z.string().min(1),
    book: z.number().min(1),
  });
};

export type BookAuthorFormValues = z.infer<ReturnType<typeof bookAuthorSchema>>;
